export default __webpack_public_path__ + "static/heels.cover-406bfc2b7ae9cb655b21ed6e74ece65f.jpg";